import React, { useState, useEffect, useContext } from "react";
import "../Review.css";
import {
  Grid,
  Box,
  Chip,
  TextField,
  Typography,
  MenuItem,
  Button,
  Divider,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Paper,
  Stack,
  Input,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CommentIcon from "@mui/icons-material/Comment";
import DialogContentText from "@mui/material/DialogContentText";
import { TextareaAutosize } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { CheckBox } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { useSelector, useDispatch } from "react-redux";
import DownloadDoneRoundedIcon from "@mui/icons-material/DownloadDoneRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import LabelImportantRoundedIcon from "@mui/icons-material/LabelImportantRounded";
//import Masonry from "@mui/lab/Masonry";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import {
  GetOrders,
  SubmitOrderModificationStickToQuota,
  setState,
  GetCurrentWeek,
  GetScenarios,
  GetUserCountries,
  GetOrderStatus,
  GetQuotaDetailsForScenario,
  reset,
  GetWeekStatus,
} from "../reviewSlice";
import MessageForReview from "../MessageForReview";
import { useNavigate } from "react-router-dom";

const ReviewButton = (params) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const reviewState = useSelector((store) => store.review);
  const { selectedCountry, selectedCountryID, selectedPeriod,getScenarios } = reviewState;

  function gotoEditScenarioMod() {
    dispatch(setState("isLoading", true));
    dispatch(setState("NavValue", 0));
    const id = params.params.row.quotaID;

    // #endregion
    dispatch(setState("isNavigate", true));
    dispatch(GetUserCountries({ method: "Get" })).then(() => {
      dispatch(GetOrderStatus({ method: "Get" }));
    });
    navigate("/review/order");
    dispatch(setState("selectedCountry", selectedCountry));
    dispatch(setState("selectedCountryID", selectedCountryID));
    dispatch(setState("searchTxt", params.params.row.scenarioName));
    dispatch(setState("selectedPeriod", selectedPeriod));
    dispatch(setState("selectedOrderStatus", "All"));
    const obj = {
      countryID: selectedCountryID,
      orderStatus: "All",
      searchText: params.params.row.scenarioName,
      period: selectedPeriod,
    };

    dispatch(GetScenarios(obj)).then(() => {
      const obj = {
        scenarioId: params.params.row.scenarioID,
        quotaId: params.params.row.quotaID,
      };
      dispatch(setState("isCollapseOpen", true));
      dispatch(setState("isLoading", true));
      dispatch(GetQuotaDetailsForScenario(obj)).then(() => {
        dispatch(setState("QCcustomerSearch", params.params.row.customerName));
        dispatch(setState("QCproductSearch", params.params.row.skuName));
        dispatch(setState("isLoading", false));
      });
    });
  }
  return (
    <>
      <IconButton onClick={gotoEditScenarioMod}>
        <EditIcon />
      </IconButton>
    </>
  );
};

const DisplayComments = (params) => {
  const [displayComments, setDisplayComments] = useState("");
  const [userComments, setUserComments] = useState("");
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleConfirm = () => {
    setDisplayComments(userComments);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        {displayComments ? <CommentIcon color="primary" /> : <CommentIcon />}
      </IconButton>

      <Dialog
        disableEnforceFocus
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TextareaAutosize
              //onChange={(event) => setUserComments(event.target.value)}
              aria-label="minimum height"
              minRows={5}
              placeholder="Comments"
              style={{ width: 500, fontSize: 18 }}
              //defaultValue={displayComments}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button autoFocus variant="contained" onClick={handleConfirm}>
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// const rows = [
//     {
//         "skuid": 25612,
//         "productGroupID": 0,
//         "skuNumb": "6077082",
//         "skuName": "IQVION 30 MG CAPS 98 PC DEU",
//         "skuType": "P",
//         "customerName": "PHOENIX Pharmahandel GmbH & Co KG Bad Kreuznach",
//         "sapCustomerNumber": "168063",
//         "scenarioID": 30052,
//         "scenarioName": "OPAG 30MG CAPS",
//         "orderStatus": "Blocked",
//         "quota": 600.0,
//         "availableQuota": 580.0,
//         "revisedQuota": 600.0,
//         "consumption": 20.0,
//         "todaysConsumption": 0.0,
//         "yesterdaysConsumption": 0.0,
//         "deliveredQty": 0.0,
//         "noOfBlockedCustomers": 0,
//         "intendedQuantity": 180.0,
//         "timeStamp": "0001-01-01T00:00:00",
//         "weekly1": 128.0,
//         "weekly2": 256.0,
//         "weekly3": 384.0,
//         "weekly4": 512.0,
//         "weekly5": 600.0,
//         "customerComments": "",
//         "customerQuotaID": 4064891,
//         "customerGroupID": 0,
//         "customerID": 881034,
//         "modifiedOrderQtyUoM": 0.0,
//         "customerTrustLevel": "Medium",
//         "depletionModel": "weeklyexactly",
//         "quotaID": 33616,
//         "stickToQuota": 1,
//         "isModified": 0,
//         "salesOrder": "202401042"
//     },
//     {
//         "skuid": 25612,
//         "productGroupID": 0,
//         "skuNumb": "6077082",
//         "skuName": "IQVION 30 MG CAPS 98 PC DEU",
//         "skuType": "P",
//         "customerName": "NOWEDA eG Schwerte",
//         "sapCustomerNumber": "168155",
//         "scenarioID": 30052,
//         "scenarioName": "OPAG 30MG CAPS",
//         "orderStatus": "Blocked",
//         "quota": 1200.0,
//         "availableQuota": 1190.0,
//         "revisedQuota": 1200.0,
//         "consumption": 10.0,
//         "todaysConsumption": 0.0,
//         "yesterdaysConsumption": 0.0,
//         "deliveredQty": 0.0,
//         "noOfBlockedCustomers": 0,
//         "intendedQuantity": 290.0,
//         "timeStamp": "0001-01-01T00:00:00",
//         "weekly1": 255.0,
//         "weekly2": 510.0,
//         "weekly3": 765.0,
//         "weekly4": 1020.0,
//         "weekly5": 1200.0,
//         "customerComments": "",
//         "customerQuotaID": 4064811,
//         "customerGroupID": 0,
//         "customerID": 675920,
//         "modifiedOrderQtyUoM": 0.0,
//         "customerTrustLevel": "High",
//         "depletionModel": "weeklyexactly",
//         "quotaID": 33616,
//         "stickToQuota": 1,
//         "isModified": 0,
//         "salesOrder": "202401041"
//     },
//     {
//         "skuid": 8219,
//         "productGroupID": 0,
//         "skuNumb": "1119350",
//         "skuName": "IQVARON 4 MG TABL 50 PC DEU BL+",
//         "skuType": "P",
//         "customerName": "Medipolis Produktion GmbH + CO.KG Jena",
//         "sapCustomerNumber": "294561",
//         "scenarioID": 30365,
//         "scenarioName": "Scenario 20230810 0956",
//         "orderStatus": "Blocked",
//         "quota": 30.0,
//         "availableQuota": 20.0,
//         "revisedQuota": 30.0,
//         "consumption": 10.0,
//         "todaysConsumption": 0.0,
//         "yesterdaysConsumption": 0.0,
//         "deliveredQty": 0.0,
//         "noOfBlockedCustomers": 0,
//         "intendedQuantity": 90.0,
//         "timeStamp": "0001-01-01T00:00:00",
//         "weekly1": 30.0,
//         "weekly2": 0.0,
//         "weekly3": 0.0,
//         "weekly4": 0.0,
//         "weekly5": 0.0,
//         "customerComments": "",
//         "customerQuotaID": 4066203,
//         "customerGroupID": 0,
//         "customerID": 976322,
//         "modifiedOrderQtyUoM": 0.0,
//         "customerTrustLevel": "High",
//         "depletionModel": "None",
//         "quotaID": 34621,
//         "stickToQuota": 0,
//         "isModified": 0,
//         "salesOrder": "202401044"
//     }
// ];
const w = 100;
const columns = [
  { field: "customerName", headerName: "Customer / CG", width: w },
  {
    field: "sapCustomerNumber",
    headerName: "Customer Number",
    flex: 1,
    renderCell: (item) => {
      return item.sapCustomerNumber === 0 ? "" : item.sapCustomerNumber;
    },
  },
  {
    field: "skuName",
    headerName: "SKU / PG",
    flex: 1,
  },
  {
    field: "skuNumb",
    headerName: "SKU Number",
    flex: 1,
  },
  {
    field: "scenarioName",
    headerName: "Scenario Name",
    flex: 1,
  },
  {
    field: "orderStatus",
    headerName: "Order status",
    flex: 1,
    renderCell: (item) => {
      return item.orderStatus === "Blocked and reviewed"
        ? "Reviewed"
        : item.orderStatus;
    },
  },
  {
    field: "quota",
    headerName: "Total Quota",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString();
      return formattedValue;
    },
  },
  {
    field: "consumption",
    headerName: "Consumption",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString();
      return formattedValue;
    },
  },
  {
    field: "availableQuota",
    headerName: "Available Quota",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString();
      return formattedValue;
    },
  },
  {
    field: "intendedQuantity",
    headerName: "Intended quantity ",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString();
      return formattedValue;
    },
  },
  {
    field: "actualQuota",
    headerName: "Actual Quota",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString();
      return formattedValue;
    },
  },
  {
    field: "review",
    headerName: "Review",
    flex: 1,
    renderCell: (params) => {
      return <ReviewButton params={params} />;
    },
  },
  // {
  //     field: "comments",
  //     headerName: "Comments",
  //     width: 150,
  //     renderCell: (params) => {
  //         return <DisplayComments params={params} />;
  //     },
  // },
  {
    field: "todaysConsumption",
    headerName: "Today's consumption",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString();
      return formattedValue;
    },
  },
  {
    field: "yesterdaysConsumption",
    headerName: "Yesterday's consumption",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString();
      return formattedValue;
    },
  },
  {
    field: "customerTrustLevel",
    headerName: "Customer relationship level",
    flex: 1,
  },
  {
    field: "stickToQuota",
    headerName: "AT - STQ",
    flex: 1,
    editable: false,
    renderCell: (item) => {
      let checked = item.row.stickToQuota;
      const label = { inputProps: { "aria-label": "Checkbox" } };
      return checked === 1 ? (
        <Checkbox {...label} defaultChecked disabled />
      ) : (
        <Checkbox {...label} disabled />
      );
    },
  },
];

const OrderModification = () => {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const apiRef = useGridApiRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [rows, setRows] = useState([]);
  const review = useSelector((state) => state.review);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  //const [filteredRows, setFilteredRows] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,
    orderStatus,
    selectedOrderStatus,
    selectedPeriod,
    getOrders,
    CurrentWeek,
  } = review;

  useEffect(() => {
    dispatch(reset("refresh orderModification"));
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, []);

  const handleCountryChange = (e) => {
    const name = e.target.value;
    console.log(countries.find((country) => country.countryName === name));
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const handleOrderStatusChange = (e) => {
    const order = e.target.value;
    dispatch(setState("selectedOrderStatus", order));
  };

  const handlePeriodChange = (e) => {
    const period = e.target.value;
    dispatch(setState("selectedPeriod", period));
  };

  const handleSearchText = (e) => {
    setSearchText(e.target.value);
  };

  const handleFilter = () => {
    // Filter the array based on the search term
    const filteredRows = getOrders?.quotaCusumptionCustomers?.filter((row) => {
      return (
        row.skuName.toLowerCase().includes(searchText.toLowerCase()) ||
        row.skuNumb.toLowerCase().includes(searchText.toLowerCase()) ||
        row.customerName.toLowerCase().includes(searchText.toLowerCase()) ||
        row.sapCustomerNumber.includes(searchText)
      );
    });
    console.log(filteredRows);
    //setRows(filteredRows);
  };

  console.log(rows);

  const handleRetrive = () => {
    if (selectedCountryID === null || selectedCountryID === "") {
      showMessage("Please select country", "info");
      return;
    }
    // if (selectedOrderStatus === null || selectedOrderStatus === "") {
    // 	showMessage("Please select order status", "info");
    // 	return;
    // }
    if (selectedPeriod === null || selectedPeriod === "") {
      showMessage("Please select period", "info");
      return;
    }

    const obj = {
      countryID: selectedCountryID,
      orderStatus: "Blocked",
      period: selectedPeriod,
    };
    dispatch(GetOrders(obj));
  };
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };
  const handleStickToQuota = () => {
    dispatch(setState("isSubmitClicked", true));
    let obj = {};
    let customerList = [];
    const newObj = {
      countryID: selectedCountryID,
      orderStatus: "Blocked",
      period: selectedPeriod,
    };

    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (row["orderStatus"].toLowerCase() == "blocked") {
        customerList.push(row.customerQuotaID);
      }
      // customerList.push(row["id"]);
    }
    if (customerList.length == 0) {
      console.log("Please select blocked customer(s)");
      showMessage("Please select blocked customer(s)", "info");
      return;
    } else {
      obj.countryId = selectedCountryID;
      obj.scenarioId = rows?.find((row) => row).scenarioID;
      obj.sceanrioName = rows?.find((row) => row).scenarioName;
      obj.blockedcustomers = customerList;
      obj.quotaId = rows?.find((row) => row).quotaID;
      obj.userId = JSON.parse(localStorage.getItem("data")).userID;
      obj.decisionCode = "SQ";
      console.log(obj);
      dispatch(SubmitOrderModificationStickToQuota(obj)).then(() =>
        dispatch(GetOrders(newObj))
      );
    }
  };

  const checkScenarioID = (array) => {
    // Assuming array is not empty and using the scenarioID of the first object as reference
    const firstScenarioID = array[0].scenarioID;
    return array.every((item) => item.scenarioID === firstScenarioID);
  };

  const handleMSQ = () => {
    if (rowSelectionModel.length > 0) {

      const date = new Date();

      var startdate = new Date(
          date.getFullYear(),
          date.getMonth(),
          1,
          6,
          30,
          0,
          0
      );
      startdate = startdate.toJSON();
      var lastdate = new Date(
          date.getFullYear(),
          date.getMonth() + 1,
          0,
          6,
          30,
          0,
          0
      );
      lastdate = lastdate.toJSON();
      if (selectedPeriod === "0") {
          startdate = new Date(
              date.getFullYear(),
              date.getMonth() - 1,
              1,
              6,
              30,
              0,
              0
          );
          startdate = startdate.toJSON();
          lastdate = new Date(
              date.getFullYear(),
              date.getMonth(),
              0,
              6,
              30,
              0,
              0
          );
          lastdate = lastdate.toJSON();
      }
      const dateObj = {
          quotaStartDate: startdate,
          quotaEndDate: lastdate
      }

      dispatch(GetWeekStatus(dateObj));

      const finalArray = rowSelectionModel.map((id) => {
        let updatedArray = apiRef.current.getRow(id);
        return updatedArray;
      });
      if (checkScenarioID(finalArray)) {
        dispatch(setState("isLoading", true));
        dispatch(setState("NavValue", 0));
        dispatch(setState("omIsDisplayBlocked", true));
        const id = finalArray[0].quotaID;

        // #endregion
        dispatch(setState("isNavigate", true));
        dispatch(GetUserCountries({ method: "Get" })).then(() => {
          dispatch(GetOrderStatus({ method: "Get" }));
        });
        navigate("/review/order");
        dispatch(setState("selectedCountry", selectedCountry));
        dispatch(setState("selectedCountryID", selectedCountryID));
        dispatch(setState("searchTxt", finalArray[0].scenarioName));
        dispatch(setState("selectedPeriod", selectedPeriod));
        dispatch(setState("selectedOrderStatus", "All"));
        dispatch(setState("selectedScenario",finalArray[0].scenarioName));
        dispatch(setState("selectedScenarioID",finalArray[0].scenarioID));
        dispatch(setState("getScenarios", []));
        const obj = {
          countryID: selectedCountryID,
          orderStatus: "All",
          searchText: finalArray[0].scenarioName,
          period: selectedPeriod,
        };

        dispatch(GetScenarios(obj)).then(() => {
          const obj = {
            scenarioId: finalArray[0].scenarioID,
            quotaId: finalArray[0].quotaID,
          };
          dispatch(setState("isCollapseOpen", true));
          dispatch(setState("isLoading", true));
          dispatch(GetQuotaDetailsForScenario(obj)).then(() => {
            // dispatch(setState("QCcustomerSearch", finalArray[0].customerName));
            // dispatch(setState("QCproductSearch", finalArray[0].skuName));
            dispatch(setState("isLoading", false));
          });
        });
      } else {
        showMessage("Please select only one scenario", "info");
        return;
      }
    } else {
      showMessage(
        "Please select the checkbox for any of the above rows",
        "info"
      );
      return;
    }
  };

  const handleUFO = () => {
    if (rowSelectionModel.length > 0) {

      const date = new Date();

      var startdate = new Date(
          date.getFullYear(),
          date.getMonth(),
          1,
          6,
          30,
          0,
          0
      );
      startdate = startdate.toJSON();
      var lastdate = new Date(
          date.getFullYear(),
          date.getMonth() + 1,
          0,
          6,
          30,
          0,
          0
      );
      lastdate = lastdate.toJSON();
      if (selectedPeriod === "0") {
          startdate = new Date(
              date.getFullYear(),
              date.getMonth() - 1,
              1,
              6,
              30,
              0,
              0
          );
          startdate = startdate.toJSON();
          lastdate = new Date(
              date.getFullYear(),
              date.getMonth(),
              0,
              6,
              30,
              0,
              0
          );
          lastdate = lastdate.toJSON();
      }
      const dateObj = {
          quotaStartDate: startdate,
          quotaEndDate: lastdate
      }

      dispatch(GetWeekStatus(dateObj));

      const finalArray = rowSelectionModel.map((id) => {
        let updatedArray = apiRef.current.getRow(id);
        return updatedArray;
      });
      if (checkScenarioID(finalArray)) {
        dispatch(setState("isLoading", true));
        dispatch(setState("NavValue", 0));
        dispatch(setState("omIsDisplayBlocked", true));
        const id = finalArray[0].quotaID;

        // #endregion
        dispatch(setState("isNavigate", true));
        dispatch(GetUserCountries({ method: "Get" })).then(() => {
          dispatch(GetOrderStatus({ method: "Get" }));
        });
        navigate("/review/order");
        dispatch(setState("selectedCountry", selectedCountry));
        dispatch(setState("selectedCountryID", selectedCountryID));
        dispatch(setState("searchTxt", finalArray[0].scenarioName));
        dispatch(setState("selectedPeriod", selectedPeriod));
        dispatch(setState("selectedOrderStatus", "All"));
        dispatch(setState("selectedScenario",finalArray[0].scenarioName));
        dispatch(setState("selectedScenarioID",finalArray[0].scenarioID));
        dispatch(setState("getScenarios", []));
        const obj = {
          countryID: selectedCountryID,
          orderStatus: "All",
          searchText: finalArray[0].scenarioName,
          period: selectedPeriod,
        };

        dispatch(GetScenarios(obj)).then(() => {
          const obj = {
            scenarioId: finalArray[0].scenarioID,
            quotaId: finalArray[0].quotaID,
          };
          dispatch(setState("isCollapseOpen", true));
          dispatch(setState("isLoading", true));
          dispatch(GetQuotaDetailsForScenario(obj)).then(() => {
            // dispatch(setState("QCcustomerSearch", finalArray[0].customerName));
            // dispatch(setState("QCproductSearch", finalArray[0].skuName));
            dispatch(setState("isLoading", false));
          });
        });
      } else {
        showMessage("Please select only one scenario", "info");
        return;
      }
    } else {
      showMessage(
        "Please select the checkbox for any of the above rows",
        "info"
      );
      return;
    }
  };

  useEffect(() => {
    const currentDate = new Date();
    const dayOfMonth = currentDate.getDate();
    let obj = JSON.parse(JSON.stringify(getOrders));
    if (getOrders?.quotaCusumptionCustomers?.length > 0) {
      for (let i = 0; i < getOrders?.quotaCusumptionCustomers.length; i++) {
        if (
          getOrders?.quotaCusumptionCustomers[i].depletionModel.toLowerCase() ==
          "none"
        ) {
          obj.quotaCusumptionCustomers[i]["actualQuota"] =
            getOrders?.quotaCusumptionCustomers[i].weekly1;
        } else if (
          getOrders?.quotaCusumptionCustomers[i].depletionModel.toLowerCase() ==
          "biweekly"
        ) {
          if (dayOfMonth <= 15) {
            obj.quotaCusumptionCustomers[i]["actualQuota"] =
              getOrders?.quotaCusumptionCustomers[i].weekly1;
          } else {
            obj.quotaCusumptionCustomers[i]["actualQuota"] =
              getOrders?.quotaCusumptionCustomers[i].weekly2;
          }
        } else {
          switch (CurrentWeek) {
            case 1:
              obj.quotaCusumptionCustomers[i]["actualQuota"] =
                getOrders?.quotaCusumptionCustomers[i].weekly1;
              break;
            case 2:
              obj.quotaCusumptionCustomers[i]["actualQuota"] =
                getOrders?.quotaCusumptionCustomers[i].weekly2;
              break;
            case 3:
              obj.quotaCusumptionCustomers[i]["actualQuota"] =
                getOrders?.quotaCusumptionCustomers[i].weekly3;
              break;
            case 4:
              obj.quotaCusumptionCustomers[i]["actualQuota"] =
                getOrders?.quotaCusumptionCustomers[i].weekly4;
              break;
            case 5:
              obj.quotaCusumptionCustomers[i]["actualQuota"] =
                getOrders?.quotaCusumptionCustomers[i].weekly5;
              break;
          }
        }
      }
      if (searchText.length > 0) {
        const filteredRows = obj?.quotaCusumptionCustomers?.filter((row) => {
          return (
            row.skuName.toLowerCase().includes(searchText.toLowerCase()) ||
            row.skuNumb.toLowerCase().includes(searchText.toLowerCase()) ||
            row.customerName.toLowerCase().includes(searchText.toLowerCase()) ||
            row.sapCustomerNumber.includes(searchText)
          );
        });
        setRows(filteredRows);
      } else {
        setRows(obj?.quotaCusumptionCustomers);
      }
    } else {
      setRows([]);
    }
  }, [getOrders]);

  useEffect(() => {
    dispatch(GetCurrentWeek({ method: "Get" }));
  }, []);

  return (
    <div>
      <Box m={2}>
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>
        <Box>
          <MessageForReview />
        </Box>
        {/* <Typography variant="subtitle2" my={2}>
                    Search for Scenario
                </Typography> */}
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        {/* <Box className="scenario-search"> */}

        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid item xs={6} sm={2} md={2} lg={3.5}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
              //select={true}
              value={countries.length > 0 ? selectedCountry.countryName : ""}
              //value={""}
              onChange={handleCountryChange}
              fullWidth
              size="small"
              //disabled={countries.length > 0 ? false : true}
              // {...register("country", {
              //     required: "Please select a country",
              // })}
              // error={Boolean(errors.country)}
              // helperText={errors ?.country ?.message}
            >
              {/* <MenuItem key={0} value={0}>
                     {"All"}
                     </MenuItem> */}
              {countries.length > 0
                ? countries.map((country, index) => {
                    return (
                      <MenuItem
                        key={country.countryID}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>
          {/* <Grid item xs={6} sm={2} md={2} lg={3}>
                        <TextField
                            variant="outlined"
                            label="Order Status"
                            select={orderStatus.length > 0 ? true : false}
                            value={orderStatus.length > 0 ? selectedOrderStatus.value : ""}
                            //select={true}
                            //value={""}
                            onChange={handleOrderStatusChange}
                            size="small"
                            fullWidth
                        //disabled={scenarioList.length > 0 ? false : true}
                        // required
                        // {...register("scenario", {
                        //     required: "Please select a scenario",
                        // })}
                        // error={Boolean(errors.scenario)}
                        // helperText={errors ?.scenario ?.message}
                        >
                            {orderStatus.length > 0 ? (
                                orderStatus.map((order, index) => {
                                    return (
                                        <MenuItem key={order.key} value={order.value}>
                                            {order.value}
                                        </MenuItem>
                                    )
                                })) : null
                            }
                        </TextField>
                    </Grid> */}
          <Grid item xs={6} sm={2} md={2} lg={3.5}>
            <TextField
              variant="outlined"
              label="Period"
              //select={quotaPeriods.length > 0 ? true : false}
              //value={quotaPeriods.length > 0 ? selectedPeriod.displayDate : ""}
              select={true}
              value={selectedPeriod ? selectedPeriod : ""}
              onChange={handlePeriodChange}
              size="small"
              fullWidth
              //disabled={quotaPeriods.length > 0 ? false : true}
              // {...register("currentPeriod", {
              //     required: "Please select validity period.",
              // })}
              // error={Boolean(errors.currentPeriod)}
              // helperText={errors ?.currentPeriod ?.message}
            >
              <MenuItem value="1">Current</MenuItem>
              <MenuItem value="0">Previous</MenuItem>
              {/* {quotaPeriods.length > 0 ? (
                            quotaPeriods.map((quota, index) => {
                                return (
                                    <MenuItem key={quota.displayDate} value={quota.displayDate}>
                                        {quota.displayDate}
                                    </MenuItem>
                                )
                            })) : null
                        } */}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={2} md={2} lg={4}>
            <TextField
              variant="outlined"
              label="Search"
              //select={countries.length > 0 ? true : false}
              //value={countries.length > 0 ? selectedCountry.countryID : " "}
              value={searchText}
              onChange={handleSearchText}
              fullWidth
              size="small"
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={1}>
            <Box justifyContent="center" display="flex">
              <Button
                startIcon={<SearchIcon />}
                variant="contained"
                onClick={handleRetrive}
                size="large"
                // className="mui_Button"
                //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
              >
                Search
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {rows?.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <DataGrid
            style={{ maxHeight: "calc(100vh - 130px)" }}
            apiRef={apiRef}
            rows={rows}
            columns={columns}
            getRowId={(row) => row?.customerQuotaID}
            sx={{ width: "100%" }}
            pageSizeOptions={[20, 50, 100]}
            // paginationMode="client"
            // initialState={{
            //     pagination: { paginationModel: { pageSize:20, page:0 }}
            // }}
            //rowSelectionModel={rowSelectionModel}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            checkboxSelection={true}
            disableRowSelectionOnClick
            disableColumnMenu
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            headerHeight={40}
          />
        </Box>
      )}
      {rows?.length > 0 && (
        <Box mt={2}>
          <Grid container columns={12} justifyContent="flex-end" spacing={2}>
            <Grid item xs={6} sm={2} md={2} lg={2.4}>
              <Button
                startIcon={<DownloadDoneRoundedIcon />}
                sx={{ width: 250, height: 45 }}
                variant="contained"
                id="SearchButton"
                disabled={!isRestrictedAccess}
                //onClick={() => SaveOrderDecision("nothing")}
                style={{
                  background: "#007DC3",
                  color: "white",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                onClick={handleMSQ}
              >
                Modify + Stick to Quota{" "}
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={2} lg={2.4}>
              <Button
                startIcon={<LockOpenRoundedIcon />}
                sx={{ width: 250, height: 45 }}
                style={{
                  background: "#007DC3",
                  color: "white",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                variant="contained"
                id="SearchButton"
                disabled={!isRestrictedAccess}
                onClick={handleUFO}
              >
                Unblock full order
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={2} lg={1.8}>
              <Button
                startIcon={<LabelImportantRoundedIcon />}
                sx={{ width: 200, height: 45 }}
                variant="outlined"
                id="SearchButton"
                disabled={!isRestrictedAccess}
                style={{
                  background: "#007DC3",
                  color: "white",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                onClick={handleStickToQuota}
              >
                Stick to quota
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  );
};

export default OrderModification;
